import { ArrowRightOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { Headline } from "../GenericComponents/Headline";

export interface WelcomePageProps {
  history: any;
}

const WelcomePage: React.SFC<WelcomePageProps> = (props) => {
  return (
    <div className="welcome-page">
      <Headline history={props.history} />
      <div className="welcome-content">
        <div className="goto-analysis-frame">
          <Button onClick={() => props.history.push("/analysis")}>
            Go to Analysis <ArrowRightOutlined />{" "}
          </Button>
        </div>
          <h1>Welcome to the “Labelizer” webserver!</h1>
        <div className="welcome-hero" style={{ display: "flex", alignItems: "flex-start", gap: 24, flexWrap: "wrap", marginTop: 8 }}>
          <div className="welcome-intro" style={{ flex: "1 1 320px" }}>
            <p>
              Are you regularly labelling proteins with dyes or other functional probes? Did you ever
              experience problems such as sticky dyes, a low degree of labelling, a non-functional protein
              after labelling or did your assay not even work after all? – If yes, we recommend that you try our
              webserver to help with the design of your assay. The Labelizer systematically selects the right
              protein residues for replacement with cysteines or unnatural amino acids. The unbiased choice
              optimizes your chances for successful labelling and to establish a functional biophysical or
              biochemical assay, e.g., dye attachment for <a href="https://en.wikipedia.org/wiki/Microscale_thermophoresis" target="_blank" rel="noopener noreferrer">MST</a>
              or <a href="https://www.nature.com/articles/s41592-023-01807-0" target="_blank" rel="noopener noreferrer">FRET</a> experiments.
            </p>
          </div>
          <div className="overview-figure" style={{ flex: "0 1 380px", maxWidth: 480 }}>
            <img src="/Overview.png" alt="Labelizer overview" style={{ width: "100%", height: "auto" }} />
          </div>
        </div>
        <h2>How does the Labelizer work (it does not use AI)? </h2>
        <p>
          Our free online service uses available structural information, i.e., a deposited structure from the PDB
          or a structural model as input for the analysis (Step 1). We established a
          <a href="https://www.nature.com/articles/s41467-025-58602-y" target="_blank" rel="noopener noreferrer"> bioinformatics procedure</a>
          using information from hundreds of successful labelling experiments on
          <a href="https://static-content.springer.com/esm/art%3A10.1038%2Fs41467-025-58602-y/MediaObjects/41467_2025_58602_MOESM3_ESM.xlsx" target="_blank" rel="noopener noreferrer"> proteins</a>
          that allows to rank all residues in your protein according to their suitability to serve as a label anchor.
          We use the conservation score, solvent accessibility, secondary structure and the type of amino acid as
          parameters (Step 2) to generate a ranking that tells you which the best positions are in your protein to
          put a label (Step 3). You can inspect that list, visualize or download it and with that at hand
          experimentally design your experiment. In an optional step you can also use the Labelizer to identify
          optimal residue pairs to design FRET assays that probe conformational changes with optimal sensitivity
          (Step 4).
        </p>
        <div className="workflow-image" style={{ textAlign: "center", marginTop: 24 }}>
          <img src="/Workflow.png" alt="Labelizer workflow" style={{ maxWidth: "100%", height: "auto" }} />
        </div>
      </div>
    </div>
  );
};

export default WelcomePage;
